<template>
  <div class="form-group input-radio" :class="{ 'form-error': error }">
    <div class="row" :class="{ 'input-radio-inline': inline }">
      <div :class="radioClass">
        <label>{{ label }}</label>
      </div>
      <div :class="radioClass"><slot /></div>
    </div>
    <p class="error-message" v-if="error">{{ errorMessage }}</p>
  </div>
</template>

<script>
export default {
  name: "input-radio",
  props: {
    label: {
      default: "Label",
      type: String,
    },
    inline: {
      default: false,
      type: Boolean,
    },
    error: {
      default: false,
      type: Boolean,
    },
    errorMessage: {
      default: "Invalid input",
      type: String,
    },
  },
  computed: {
    radioClass: function () {
      return this.inline ? "col-6" : "col-12";
    },
  },
};
</script>
